import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import infoList from "@/components/mixins/infoList";
import { addFileRoleWithUser, getUserByRoleId, getUserNotInByRoleId } from '@/api/file_role';
// import { addFolderUser,getUserByFolderId,getUserByNotInFolderId } from "@/api/file_service";

export default {
  name: "Users",
  mixins: [infoList],
  data: function data() {
    return {
      userTransferData: [],
      userTransferModel: []
    };
  },
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  methods: {
    saveFileRoleWithUsers: function () {
      var _saveFileRoleWithUsers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var userids;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              userids = [];
              this.userTransferModel && this.userTransferModel.map(function (item) {
                userids.push(item);
              });
              _context.next = 1;
              return addFileRoleWithUser({
                Users: userids,
                RoleId: this.row.ID
              });
            case 1:
              return _context.abrupt("return", _context.sent);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function saveFileRoleWithUsers() {
        return _saveFileRoleWithUsers.apply(this, arguments);
      }
      return saveFileRoleWithUsers;
    }(),
    filterMethod: function filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    LoadLeftUser: function () {
      var _LoadLeftUser = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, users;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getUserNotInByRoleId({
                RoleId: this.row.ID
              });
            case 1:
              res = _context2.sent;
              users = res.data.Users;
              if (!(users == null || users.length <= 0)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              this.userTransferData = users.map(function (user) {
                return {
                  key: user.ID,
                  label: user.nickName
                };
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function LoadLeftUser() {
        return _LoadLeftUser.apply(this, arguments);
      }
      return LoadLeftUser;
    }(),
    LoadRightUser: function () {
      var _LoadRightUser = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this = this;
        var res, users;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return getUserByRoleId({
                RoleId: this.row.ID
              });
            case 1:
              res = _context3.sent;
              users = res.data.Users;
              if (!(users == null || users.length <= 0)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              // console.log(JSON.stringify(users))
              users.map(function (user) {
                _this.userTransferData.push({
                  key: user.ID,
                  label: user.nickName
                });
                _this.userTransferModel.push(user.ID);
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function LoadRightUser() {
        return _LoadRightUser.apply(this, arguments);
      }
      return LoadRightUser;
    }()
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 1;
            return this.LoadLeftUser();
          case 1:
            _context4.next = 2;
            return this.LoadRightUser();
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }()
};